import React from 'react'
const RowBotonesTopThin = (props) => {
    return (
        <div className={props.extra || "p-col p-col-auto"}>
            <div className="btn-row">
                {props.children}
            </div>
        </div>)
}
export default RowBotonesTopThin;